// extracted by mini-css-extract-plugin
export default {"container":"FeedbackOption_container__ehdDj","btn":"FeedbackOption_btn__0FHGj"};